import Cookies from "js-cookie";

function getUKTimeParts() {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(new Date());

  const getPart = (type) => parts.find((part) => part.type === type)?.value;

  return {
    weekday: getPart("weekday"),
    hour: parseInt(getPart("hour"), 10),
    minute: parseInt(getPart("minute"), 10),
  };
}

function isPopupVisibleTimeUK() {
  const { weekday, hour, minute } = getUKTimeParts();

  if (weekday === "Monday") {
    return hour >= 3;
  }

  if (["Tuesday", "Wednesday"].includes(weekday)) {
    return true;
  }

  if (weekday === "Thursday") {
    return hour < 1 || (hour === 1 && minute < 30);
  }

  return false;
}

function PopupAction() {
  console.log("PopupAction running...");
  const popupAction = document.querySelector(".popup-action");

  if (!popupAction) {
    console.warn("No element with .popup-action found");
    return;
  }

  if (!isPopupVisibleTimeUK()) {
    console.log("Popup hidden outside Monday 03:00 to Thursday 01:30 UK time");
    return;
  }

  const name = popupAction.dataset.name;
  const expires = parseInt(popupAction.dataset.expires) || 7;

  console.log("Checking cookie:", name, Cookies.get(name));

  if (!Cookies.get(name)) {
    console.log("No cookie found — showing popup");
    popupAction.classList.remove("hidden-menu");
  } else {
    console.log("Cookie exists — keeping popup hidden");
  }

  const closeBtn = popupAction.querySelector(".popup-close");

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      console.log("Close button clicked — hiding popup & setting cookie");
      popupAction.classList.add("hidden-menu");
      Cookies.set(name, "true", { expires });
    });
  }

  setInterval(function () {
    if (!isPopupVisibleTimeUK()) {
      popupAction.classList.add("hidden-menu");
    }
  }, 15000);
}

export default PopupAction;
